module.exports = __webpack_public_path__ + "static/subscribe-to-updates-cee35084429b7f7620822e57d95e3004.png";